//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PublicService from '@/service/public'
import { openChat } from '@/data/im'
export default {
    computed: {
    },
    props: {
        loan_computer_url: String,
        show_consultant: Boolean,
        building_id: [String, Number],
        padding_top: {
            type: Number,
            default: 12
        },
        padding_bottom: {
            type: Number,
            default: 12
        }
    },
    methods: {
        goLink(){
            this.$sendCtmEvtLog('参考价格-算房贷点击')
            wx.navigateTo({
                url: this.loan_computer_url
            })
        },
        async consult () {
            // this.$bindLogEvt('building-detail-consult-price')
            const consultant = await PublicService.getRecommendConsultant({
                scene: 'building_detail_consult_price',
                building_id: this.building_id
            })
            console.log(consultant);
            openChat(consultant.id, {
                from: '询价格',
                building_id: this.building_id
            })
        }
    }
}
